import { requestService } from "@/api/alice";

export default {
  requestService(
    { commit, rootState },
    { from, to, dueTime, serviceId, serviceMessage }
  ) {
    commit("REQUEST_REQUEST_SERVICE");

    const propertyId = rootState.session.propertyId || "";
    const room = rootState.session.authResult.room || "";
    const lastname = rootState.session.authResult?.checkin[0]?.last_name || "";

    if (!propertyId) {
      commit("FAILED_REQUEST_SERVICE");
      // eslint.disable-next-line no-console
      console.error("failed to request service: missing propertyId");
      return;
    }

    if (!room) {
      commit("FAILED_REQUEST_SERVICE");
      // eslint.disable-next-line no-console
      console.error("failed to request service: missing room");
      return;
    }

    if (!lastname) {
      commit("FAILED_REQUEST_SERVICE");
      // eslint.disable-next-line no-console
      console.error("failed to request service: missing lastname");
      return;
    }
    requestService({
      propertyId,
      room,
      lastname,
      from,
      to,
      dueTime,
      serviceId,
      serviceMessage,
    })
      .then((response) => {
        commit("SUCCESS_REQUEST_SERVICE", response);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("failed to request service:", err);
        commit("FAILED_REQUEST_SERVICE");
      });
  },
};
